export default "__VITE_ASSET__DRgRG5sq__"